module.exports = "<aside class=\"aside-menu\">\n  \n</aside>\n"


//////////////////
// WEBPACK FOOTER
// /var/jenkins_home/workspace/srd-proinvel-pipeline/src/app/components/app-aside/app-aside.component.html
// module id = ../../../../../src/app/components/app-aside/app-aside.component.html
// module chunks = main